/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Stack } from './Stack.js';

const HStack = /*#__PURE__*/React__default.forwardRef(function HStack(_ref, ref) {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Stack, _extends({}, props, {
    ref: ref,
    orientation: "horizontal"
  }), children);
});

export { HStack };
